export const getLocalizedValue = (value: any, locale: string): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    return locale === 'ar' ? value.ar || value.en || '' : value.en || value.ar || '';
  }
  return String(value);
};

export const categoryHasImage = (category: any): boolean => {
  if (!category) return false;
  const nameEn = (category?.name?.en || '').toLowerCase();
  const nameAr = category?.name?.ar || '';
  const slug = (category?.slug || '').toLowerCase();
  return (
    nameEn.includes('with a picture') ||
    nameEn.includes('with picture') ||
    nameEn.includes('with image') ||
    nameEn.includes('picture') ||
    nameAr.includes('مع صورة') ||
    nameAr.includes('صورة') ||
    slug.includes('picture') ||
    slug.includes('image')
  );
};
